module.exports = __webpack_public_path__ + "static/media/green_state@2x.efd27a2c.png";